import { motion, AnimatePresence } from "framer-motion";
import React, { useState, useEffect } from "react";
import Logo from '../assets/colored_logo.svg';

interface LoaderProps {
    onFinish: () => void;
}

const Loader: React.FC<LoaderProps> = ({ onFinish }) => {
    const [exit, setExit] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setExit(true);
            setTimeout(onFinish, 500);
        }, 1000);

        return () => clearTimeout(timer);
    }, [onFinish]);

    return (
        <AnimatePresence>
            {!exit && (
                <motion.div
                    className="fixed top-0 left-0 w-full h-full flex items-center justify-center z-50"
                    style={{
                        background: "linear-gradient(90deg, rgb(8, 9, 23), rgb(27, 30, 77))"
                    }}
                    initial={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.5 }}
                >
                    <motion.img
                        src={Logo}
                        alt="Logo"
                        className="w-32 h-32"
                        initial={{ scale: 0.5, opacity: 0 }}
                        animate={{
                            scale: [0.5, 1.2, 1], // Effet de pulsation
                            opacity: [0, 1, 1],
                            rotate: [0, 360], // Rotation fluide
                        }}
                        exit={{ scale: 0, opacity: 0 }}
                        transition={{
                            duration: 1.5,
                            ease: "easeInOut"
                        }}
                    />
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default Loader;